import { Geolocation } from "@/lib/geolocation"
import { isString } from "@/lib/validation/isString"

export const isDistanceKey = (
  subject: unknown
): subject is Geolocation.DistanceKey => {
  if (isString(subject)) {
    return Geolocation.distanceKeys.includes(subject as Geolocation.DistanceKey)
  }

  return false
}
